import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export const SERVICE_UNAVALABLE_MESSAGE = {
    id: 'service-unavailable',
    text: _('global.messages.service-unavailable.text'),
};
